import React from 'react'
import Button from '../../components/atoms/Button';

const ModalInformation = ({show, title, content, icon, actYes, actNo, actClose}) => {
    return (
        <div className={`kc-modal ${!show && 'kc-modal-hiden'}`}>
            <div className='kc-modal-dialog'>
                <button type="button" className="kc-modal-close" onClick={actClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
                
                <div className='kc-modal-content'>
                    {icon && <img className='icon' src={icon} alt='' />}
                    <h1>{title}</h1>
                    {typeof content === 'string' ? <p>{content}</p> : content }

                    <div className='kc-modal-button'>
                        {actYes  && <Button type='button' title={actYes.title} color="yellow" width="big-rounded" onClick={actYes.action} />}
                        {actNo && <Button type='button' title={actNo.title} color="outline" width="big-rounded" onClick={actNo.action} />}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalInformation;